import {Routes} from '@angular/router';
import {MapComponent} from './map/map.component';
import {AuditSmsComponent} from "./audit/audit-sms/audit-sms.component";
import {LoggingSmsComponent} from "./audit/logging-sms/logging-sms.component";
import {Mapv2Component} from "./mapv2/mapv2.component";

export const APP_ROUTES: Routes = [

  {path: 'accueil', component: Mapv2Component},
  // {path: 'accueil', component: MapComponent},
  {
    path: '',
    redirectTo: 'accueil',
    pathMatch: 'full',
    // canActivate: [AuthGuardService]
  },
  {path: 'nup/:nup', component: Mapv2Component},
  // {path: 'nup/:nup', component: MapComponent},
  {path: 'audit2', component: AuditSmsComponent},
  {path: 'audit', component: LoggingSmsComponent},
  // { path: '**', component: ErrorComponent },
];
